import { is } from 'ramda';
import {  Icon  } from "@mui/material";

interface ValueProps {
	value: any;
}

export default class Value extends React.PureComponent<ValueProps> {
	render() {
		const { value } = this.props;

		const empty = <div>{window.Alfresco.messages.global['label.none']}</div>;

		if (!value) {
			return empty;
		}

		if (Array.isArray(value)) {
			if (value.length === 0) {
				return empty;
			}

			return (
				<div>
					{value
						.filter(item => {
							if (!item.name) {
								return !!item;
							}

							return (
								!item.name.toLowerCase().startsWith('alfresco') &&
								!item.name.toLowerCase().startsWith('site') &&
								!item.name.toLowerCase().startsWith('email')
							);
						})
						.map((item, index) => {
							const label = index === value.length - 1 ? item.label : item.label + ',';
							if (item.value) {
								return (
									<p key={item.value} className="view-authority">
										{item.type === 'cm:person' || item.type === 'USER' ? (
											<a
												className="cm-person"
												href={`${window.appContext}/page/user/${item.userName}/profile`}
												target="_blank"
											>
												<Icon className="fas fa-user" fontSize="small" />
												{label}
											</a>
										) : (
											<React.Fragment>
												<Icon className="fas fa-users" fontSize="small" />
												{label}
											</React.Fragment>
										)}
									</p>
								);
							}

							return '';
						})}
				</div>
			);
		}

		if (is(Object, value)) {
			return (
				<div>
					<p className="view-authority">
						{value.type === 'cm:person' ? (
							<a
								className="cm-person"
								href={`${window.appContext}/page/user/${value.userName}/profile`}
								target="_blank"
							>
								<Icon className="fas fa-user" fontSize="small" />
								{value.label}
							</a>
						) : (
							<React.Fragment>
								<Icon className="fas fa-users" fontSize="small" />
								{value.label}
							</React.Fragment>
						)}
					</p>
				</div>
			);
		}

		return value || empty;
	}
}
